







import {Component, Prop} from 'vue-property-decorator';
import {mixins}          from 'vue-class-component';
import Loading           from '@/components/loading/Loading.vue';
import MainMixin         from '@/mixins/Main';

@Component({
    components: {
        Loading
    },
    name: `LoadingContainer`
})
export default class LoadingContainer extends mixins(MainMixin)
{
    @Prop({default: false, type: Boolean}) public readonly condition!: boolean;
}
